/* Doppel Ducks theme JS — mobile menu, hotline modal, toast, cart count */

function toggleMenu(){
  const m = document.getElementById('mmenu');
  if(!m) return;
  const open = m.classList.toggle('open');
  const b = document.querySelector('.burger');
  if(b) b.setAttribute('aria-expanded', open);
}
function closeMenu(){
  const m = document.getElementById('mmenu');
  if(m) m.classList.remove('open');
  const b = document.querySelector('.burger');
  if(b) b.setAttribute('aria-expanded','false');
}

/* hotline modal */
function openHotline(){ const o=document.getElementById('hotlineModal'); if(o) o.classList.add('open'); }
function closeHotline(){ const o=document.getElementById('hotlineModal'); if(o) o.classList.remove('open'); }

/* duck-card art fitting: measure each art file's real (non-transparent) bounds
   and scale/center it to fill the card frame — exports vary in padding. */
function fitDuckArt(img){
  try{
    const w = 64, h = 80;
    const c = document.createElement('canvas'); c.width = w; c.height = h;
    const x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, w, h);
    const d = x.getImageData(0, 0, w, h).data;
    let minX = w, minY = h, maxX = -1, maxY = -1;
    for(let j = 0; j < h; j++) for(let i = 0; i < w; i++){
      if(d[(j * w + i) * 4 + 3] > 10){
        if(i < minX) minX = i; if(i > maxX) maxX = i;
        if(j < minY) minY = j; if(j > maxY) maxY = j;
      }
    }
    if(maxX <= minX || maxY <= minY) return;
    const bw = (maxX - minX + 1) / w, bh = (maxY - minY + 1) / h;
    const cx = (minX + maxX + 1) / 2 / w, cy = (minY + maxY + 1) / 2 / h;
    const k = Math.min(0.94 / bw, 0.94 / bh, 1.9);
    img.style.transform = `translate(${((0.5 - cx) * 100 * k).toFixed(2)}%, ${((0.5 - cy) * 100 * k).toFixed(2)}%) scale(${k.toFixed(3)})`;
  }catch(e){ /* CORS-tainted or decode issue: keep the CSS fallback scale */ }
}
function initDuckArtFit(){
  document.querySelectorAll('img[data-fit-duck]').forEach(function(img){
    if(img.complete && img.naturalWidth) fitDuckArt(img);
    else img.addEventListener('load', function(){ fitDuckArt(img); }, { once: true });
  });
}

/* header search: predictive results; empty result set routes to the hotline */
function toggleSearch(){
  const p = document.getElementById('ddSearch');
  if(!p) return;
  const open = p.classList.toggle('open');
  const b = document.querySelector('.search-btn');
  if(b) b.setAttribute('aria-expanded', open);
  if(open){ closeMenu(); const i = document.getElementById('ddSearchInput'); if(i) setTimeout(()=>i.focus(), 60); }
}
function closeSearch(){
  const p = document.getElementById('ddSearch');
  if(p) p.classList.remove('open');
  const b = document.querySelector('.search-btn');
  if(b) b.setAttribute('aria-expanded','false');
}
let ddSearchTimer, ddSearchSeq = 0;
function ddPredictive(q){
  const box = document.getElementById('ddSearchResults');
  if(!box) return;
  if(q.length < 2){ box.innerHTML = ''; return; }
  const seq = ++ddSearchSeq;
  /* full search via a JSON view — unlike suggest.json it matches TAGS,
     where the doppelganger real names live ("chaplin" -> Charlie Quacklin) */
  fetch('/search?q=' + encodeURIComponent(q) + '&type=product&view=suggest')
    .then(r => r.json())
    .then(d => {
      if(seq !== ddSearchSeq) return; /* stale response */
      const ducks = (d.products || []).slice(0, 6);
      if(!ducks.length){
        box.innerHTML = '<div class="search-empty"><b>No duck by that name 🦆</b>' +
          '<p>Sounds like a job for the hotline — most-requested legend gets drawn &amp; dropped.</p>' +
          '<button class="btn red" onclick="closeSearch();openHotline()">📞 Request this duck</button></div>';
        return;
      }
      box.innerHTML = ducks.map(p =>
        '<a class="search-hit" href="' + p.url + '">' +
        (p.img ? '<img src="' + p.img + '" width="40" height="40" alt="">' : '') +
        '<span>' + p.title + '</span><b>' + (p.price || '') + '</b></a>'
      ).join('') +
      '<a class="search-all" href="/search?q=' + encodeURIComponent(q) + '">See all results →</a>';
    })
    .catch(()=>{ /* network hiccup: keep whatever is shown */ });
}
document.addEventListener('DOMContentLoaded', function(){
  const i = document.getElementById('ddSearchInput');
  if(i) i.addEventListener('input', function(){
    clearTimeout(ddSearchTimer);
    ddSearchTimer = setTimeout(()=>ddPredictive(i.value.trim()), 220);
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeSearch(); });
  document.addEventListener('click', function(e){
    const p = document.getElementById('ddSearch');
    if(p && p.classList.contains('open') && !p.contains(e.target) && !e.target.closest('.search-btn')) closeSearch();
  });
});

/* toast */
let ddToastTimer;
function toast(msg){
  const t = document.getElementById('toast');
  if(!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(ddToastTimer);
  ddToastTimer = setTimeout(()=>t.classList.remove('show'), 2600);
}

document.addEventListener('DOMContentLoaded', function(){
  initDuckArtFit();
  const modal = document.getElementById('hotlineModal');
  if(modal){
    modal.addEventListener('click', e => { if(e.target === modal) closeHotline(); });
    /* auto-open with success state after a contact-form submission */
    if(modal.dataset.posted === 'true') openHotline();
  }
  document.addEventListener('keydown', e => { if(e.key === 'Escape'){ closeHotline(); closeMenu(); } });

  /* close mobile menu when a link inside it is used */
  const mm = document.getElementById('mmenu');
  if(mm) mm.addEventListener('click', e => { if(e.target.closest('a')) closeMenu(); });

  /* live cart count */
  const cc = document.getElementById('cartCount');
  if(cc){
    fetch('/cart.js').then(r=>r.json()).then(c=>{ cc.textContent = c.item_count; }).catch(()=>{});
  }
});
